import React, { FC, ReactElement } from 'react';
import { Text } from 'grommet';
import { TextExtendedProps } from 'grommet/components/Text';

export const Subheading: FC<TextExtendedProps> = ({
  children,
  ...rest
}): ReactElement => (
  <Text size="xsmall" color="brand" {...rest}>
    {children}
  </Text>
);
